
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/size-chart",
      function () {
        return require("private-next-pages/info/size-chart.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/size-chart"])
      });
    }
  